module.exports = __webpack_public_path__ + "img/live-bar-gift.dc4cebdd.svg";